import { IAppState } from '../../AppModulesWrapper';

import { EWebviewHostActionName } from '../types/reducers/webview';

export const selectWebviewHostActionName = (state: IAppState): EWebviewHostActionName | null => {
  return state.webview.hostActionName;
};
